import ReferenceSkillsHelper from './models/ReferenceSkillsHelper';

export default { referenceSkills: ReferenceSkillsHelper };
